import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type {
  TransactionHubMenuDTO,
  TransactionMenuItemDTO,
  TransactionFormConfigDTO,
  TransactionResultDTO,
  ViewMode,
  TransactionHubState,
  TransactionHubActions,
} from '../types';

const initialState: TransactionHubState = {
  menuData: null,
  menuLoading: false,
  menuError: null,
  selectedTransaction: null,
  formConfig: null,
  executionResult: null,
  isExecuting: false,
  executionError: null,
  favorites: [],
  recentTransactions: [],
  viewMode: 'category',
  searchQuery: '',
  selectedCategory: null,
};

export const useTransactionHubStore = create<TransactionHubState & TransactionHubActions>()(
  persist(
    (set, get) => ({
      ...initialState,

      setMenuData: (data) => set({ menuData: data }),
      setMenuLoading: (loading) => set({ menuLoading: loading }),
      setMenuError: (error) => set({ menuError: error }),

      setSelectedTransaction: (transaction) => set({ selectedTransaction: transaction }),
      setFormConfig: (config) => set({ formConfig: config }),

      setExecutionResult: (result) => set({ executionResult: result }),
      setIsExecuting: (isExecuting) => set({ isExecuting: isExecuting }),
      setExecutionError: (error) => set({ executionError: error }),

      toggleFavorite: (transactionCode) => {
        const { favorites } = get();
        if (favorites.includes(transactionCode)) {
          set({ favorites: favorites.filter((code) => code !== transactionCode) });
        } else {
          set({ favorites: [...favorites, transactionCode] });
        }
      },

      isFavorite: (transactionCode) => {
        return get().favorites.includes(transactionCode);
      },

      addToRecent: (transaction) => {
        const { recentTransactions } = get();
        const filtered = recentTransactions.filter((t) => t.code !== transaction.code);
        set({ recentTransactions: [transaction, ...filtered].slice(0, 10) });
      },

      clearRecent: () => set({ recentTransactions: [] }),

      setViewMode: (mode) => set({ viewMode: mode }),

      setSearchQuery: (query) => set({ searchQuery: query }),

      setSelectedCategory: (category) => set({ selectedCategory: category }),

      reset: () =>
        set({
          ...initialState,
          favorites: get().favorites,
          recentTransactions: get().recentTransactions,
        }),
    }),
    {
      name: 'transaction-hub-storage',
      partialize: (state) => ({
        favorites: state.favorites,
        recentTransactions: state.recentTransactions,
      }),
    }
  )
);
